import { TRarity, TSchemaName } from "@pro/common/conf";
import { app } from "../App";
import { BookModel } from "../stores/BookModel";
import { HeroModel } from "../stores/HeroModel";
import { StakedAssetModel } from "../stores/StakedAssetModel";
import { SymbolModel } from "../stores/SymbolModel";

export type CustomTSchema = Exclude<TSchemaName, "packs">

export type CustomAsset = BookModel | SymbolModel | HeroModel | StakedAssetModel

export type AssetsByRarityType2 = {
	[key in TRarity | 'all']: CustomAsset[]
}

export type AssetSortedTemplateType2 = {
	[key in CustomTSchema]: AssetsByRarityType2
};

export const getAllBadges = (tabAsset: AssetsByRarityType2) => {
	let all = 0, common = 0, rare = 0, unique = 0, epic = 0, legendary = 0, mythic = 0

	all = tabAsset?.all?.length || 0
	common = tabAsset?.common?.length || 0
	rare = tabAsset?.rare?.length || 0
	unique = tabAsset?.unique?.length || 0
	epic = tabAsset?.epic?.length || 0
	legendary = tabAsset?.legendary?.length || 0
	mythic = tabAsset?.mythic?.length || 0

	return {
		all,
		common,
		rare,
		unique,
		epic,
		legendary,
		mythic,
	}
}

export const useCards = ({ useUnstakeOnly, useAll }: { useAll?: boolean, useUnstakeOnly?: boolean }) => {
	const assets: AssetSortedTemplateType2 = {
		books: {
			all: [],
			common: [],
			rare: [],
			unique: [],
			epic: [],
			legendary: [],
			mythic: [],
		},
		symbols: {
			all: [],
			common: [],
			rare: [],
			unique: [],
			epic: [],
			legendary: [],
			mythic: [],
		},
		heroes: {
			all: [],
			common: [],
			rare: [],
			unique: [],
			epic: [],
			legendary: [],
			mythic: [],
		},
	}

	const q = <T>(common: T[], epic: T[], rare: T[], unique: T[], legendary: T[], mythic: T[]) => {
		return {
			all: common.concat(epic).concat(rare).concat(unique).concat(legendary).concat(mythic),
			common,
			epic,
			rare,
			unique,
			legendary,
			mythic,
		}
	}

	const queryBooks = () => {
		const common: BookModel[] = app.store.books.queryByRarity("common")
		const epic: BookModel[] = app.store.books.queryByRarity("epic")
		const rare: BookModel[] = app.store.books.queryByRarity("rare")
		const unique: BookModel[] = app.store.books.queryByRarity("unique")
		const legendary: BookModel[] = app.store.books.queryByRarity("legendary")
		const mythic: BookModel[] = app.store.books.queryByRarity("mythic")

		assets.books = q<BookModel>(common, epic, rare, unique, legendary, mythic)
	}

	const querySymbols = () => {
		const common: SymbolModel[] = app.store.symbols.queryByRarity("common")
		const epic: SymbolModel[] = app.store.symbols.queryByRarity("epic")
		const rare: SymbolModel[] = app.store.symbols.queryByRarity("rare")
		const unique: SymbolModel[] = app.store.symbols.queryByRarity("unique")
		const legendary: SymbolModel[] = app.store.symbols.queryByRarity("legendary")
		const mythic: SymbolModel[] = app.store.symbols.queryByRarity("mythic")

		assets.symbols = q<SymbolModel>(common, epic, rare, unique, legendary, mythic)
	}

	const queryHeroes = () => {
		const common: HeroModel[] = app.store.heroes.queryByRarity("common")
		const epic: HeroModel[] = app.store.heroes.queryByRarity("epic")
		const rare: HeroModel[] = app.store.heroes.queryByRarity("rare")
		const unique: HeroModel[] = app.store.heroes.queryByRarity("unique")
		const legendary: HeroModel[] = app.store.heroes.queryByRarity("legendary")
		const mythic: HeroModel[] = app.store.heroes.queryByRarity("mythic")

		assets.heroes = q<HeroModel>(common, epic, rare, unique, legendary, mythic)
	}

	if (useUnstakeOnly) {
		const stakedData: StakedAssetModel[] = app.store.stakedAssets.queryAll();
		stakedData.forEach((it: StakedAssetModel) => {
			if (it.schemaName !== "packs") {
				assets[it.schemaName as CustomTSchema][it.rarity as TRarity].push(it)
				assets[it.schemaName as CustomTSchema].all.push(it)
			}
		})
	} else {
		queryBooks()
		querySymbols()
		queryHeroes()

		if (useAll) {
			const stakedData: StakedAssetModel[] = app.store.stakedAssets.queryAll();
			stakedData.forEach((it: StakedAssetModel) => {
				if (it.schemaName !== "packs") {
					assets[it.schemaName as CustomTSchema][it.rarity as TRarity].push(it)
					assets[it.schemaName as CustomTSchema].all.push(it)
				}
			})
		}
	}


	return assets
}
